module.exports = __webpack_public_path__ + "fonts/loading-fonts3.d3fb1c1.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/loading/loading-fonts3.woff
// module id = ./assets/loading/loading-fonts3.woff
// module chunks = 2 3 4 5 6 7 8